<template>
    <div class="spo-card rounded bordered p-1 my-2">
        <div class="text-h6">{{ plan_entrainement.titre }}</div>
        <v-checkbox v-if="!is_changement_parcours" color="primary-dark" hide-details
            @change="$emit('changePlanEntrainement')" :label="checkbox_label"
            v-model="plan_entrainement.selected"></v-checkbox>


        <div class="text-body mt-2 plan-entrainement-description" v-if="plan_entrainement.description">
            {{ plan_entrainement.description }}
        </div>
    </div>
</template>

<script>
export default {
    props: ["item", "initial_commande_inscription"],
    data() {
        return {
            plan_entrainement: {},
        };
    },
    computed: {
        is_changement_parcours() {
            return this.initial_commande_inscription;
        },
        checkbox_label() {
            return "Souscrire au " + this.plan_entrainement.titre + " pour " + this.plan_entrainement.prix + "€";
        },
    },
    mounted() {
        this.plan_entrainement = this.item;
    },
}
</script>

<style lang="scss" scoped>
.plan-entrainement-description {
    white-space: pre-line;
}
</style>
